import Header from 'components/_OldDesign/header'
import React, { ReactElement, useEffect, useState } from 'react'
import style from 'styles/Content.module.scss'
import { GetStaticProps } from 'next';
import 'react-multi-carousel/lib/styles.css';
import { strapi } from 'models/conent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import Link from 'next/link';
import Carousel from 'react-multi-carousel';
import Subscribe from 'components/_OldDesign/subscribe';
import ModalVideo from 'react-modal-video'
import moment from 'moment';
import fetchStrapi from 'lib/fetchStrapi';
import OldLayout from '@components/_OldDesign/OldLayout';
import { NextPageWithLayout } from './_app';
import { Lang, useLocale } from '@components/Contexts/LocaleContext';
import { omitDeep } from 'lodash-omitdeep';

export const getStaticProps: GetStaticProps = async () => {
  try {
    let contents = await fetchStrapi('/blogs', 2);
    let categories = await fetchStrapi('/categories', 3);

    contents = omitDeep(contents, ['description', 'descriptionTH', 'formats', 'detail', 'detailTH']);
    categories = omitDeep(categories, ['description', 'descriptionTH', 'formats', 'detail', 'detailTH']);

    return {
      props: {
        contents,
        categories
      },
    };
  } catch (error) {
    return {
      props: {
        data: JSON.stringify(error),
      },
    };
  }
}

const responsive = {
  desktop: {
    breakpoint: { max: 5000, min: 1280 },
    items: 5
  },
  tablet: {
    breakpoint: { max: 1279, min: 640 },
    items: 3
  },
  mobile: {
    breakpoint: { max: 640, min: 0 },
    items: 1
  }
};

const categoriesResponsive = {
  tablet: {
    breakpoint: { max: 5000, min: 1024 },
    items: 3
  },
  mobile: {
    breakpoint: { max: 1023, min: 0 },
    items: 1
  }
};

const Blogs: NextPageWithLayout = ({ contents, categories }: {contents: any, categories: any[]}) => {  
  const [content, setContent] = useState(null);
  const [tag, setTag] = useState<any[]>([]);
  const [search, setSearch] = useState<string>('')
  const [isOpen, setOpen] = useState(false);
  const {lang, setLang} = useLocale();
  const [hoverTag, setHoverTag] = useState<number>(0);

  useEffect(() => {
    setContent(contents);
    setLang((localStorage.getItem('lang') ?? 'th') as Lang);
    
    setTag(
      contents?.map((element: any) => element.tags)
        .reduce((a: any, b: any) => a.concat(b), [])
        .map((el: any) => el.tag).filter((item: any, i: any, ar: any) => ar.indexOf(item) === i)
    );

    // console.log(categories);
    // console.log(content);
    // console.log(content?.filter((item: any) => item?.recommend).sort((a, b) => a.recommend.sequence - b.recommend.sequence));
    
    
  }, [])
  useEffect(() => {
  }, [tag])


  function calculateRead(item: any) {
    moment.locale(lang);
    return item ? (lang === 'th' ? 'อ่านเมื่อ ' + moment(item).fromNow() : moment(item).fromNow()?.toUpperCase() + ' READ') : null;
  }

  function truncateString(str: any) {
    if (str?.length > 85) {
      return str.substring(0, 85) + '...';
    } else {
      return str;
    }
  }

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      window.location.href = '/categories?tag=' + e.target?.value;
    }
  }
  return <>
    <div className="px-12 xl:px-24">
      <Header content={ {
        title: 'CODIUM Blogs - อัปเดตข่าวสารและความรู้ด้านดิจิทัล',
        content: 'ติดตามบทความและข้อมูลเชิงลึกจาก CODIUM รวมถึงเทคโนโลยีใหม่ล่าสุด e-Signature, e-Tax, Digital Transformation และโซลูชันดิจิทัลสำหรับธุรกิจ',
        image: null,
      } }/>

      <div className={ `h-full w-full relative pt-40 pb-12 md:pt-24` }>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20">
          <div className="grid grid-cols-3 align-self-center">
            <div className="bg-dark-blue border-dark-blue border-2 text-center text-white py-4 md:py-1 cursor-pointer rounded-l-xl">
              <span className="text-4xl md:text-xl lg:text-2xl">Blogs</span>
            </div>
            <Link href="/issues">
              <div
                className="border-dark-blue border-t-2 border-b-2 text-center py-4 md:py-1 cursor-pointer ">
                <span className="text-4xl md:text-xl lg:text-2xl underline">Issues</span>
              </div>
            </Link>
            <Link href="/categories">
              <div className="border-dark-blue border-2 text-center py-4 md:py-1 cursor-pointer rounded-r-xl">
                <span className="text-4xl md:text-xl lg:text-2xl underline">Categories</span>
              </div>
            </Link>
          </div>
          <div className="relative">
            <input type="text"
              className={ `${ style.outlineNone } ${ style.search } xl:m-auto bg-white border-b w-full lg:mx-8 border-dark-blue px-2 text-dark-blue h-20 lg:h-12 text-2xl md:text-xl lg:text-2xl` }
              placeholder="Search Tag" value={ search }
              onKeyDown={ (e) => handleKeyDown(e) }
              onChange={ (e) => {
                setSearch(e.target.value)
              } }/>
            <FontAwesomeIcon icon={ faSearch }
              className="absolute right-3 text-2xl fa-2x top-5 lg:top-2 text-dark-blue"/>
          </div>
        </div>
      </div>

      <div className="grid grid-rows-1 lg:grid-cols-2">
        <Link
          href={ '/blogs/' + content?.filter((item: any) => item?.recommend)?.sort((a, b) => a.recommend.sequence - b.recommend.sequence)[0].id + '-' + content?.filter((item:any) => item.recommend)?.sort((a, b) => a.recommend.sequence - b.recommend.sequence)[0].url }>
          <div
            className="m-4 shadow-2xl bg-white cursor-pointer relative xl:h-auto bg-no-repeat bg-cover bg-center rounded-2xl flex flex-col-reverse h-40"
            style={ { backgroundImage: `url(${ strapi }${ content?.filter(item => item.recommend)?.sort((a, b) => a.recommend.sequence - b.recommend.sequence)[0].image?.url })` } }>
            <div className="px-6 py-10 relative text-white trans-bg">
              { content?.filter(item => item.recommend)?.sort((a, b) => a.recommend.sequence - b.recommend.sequence)[0].categories?.map((item, i) =>
                  <span key={ i }>
                { i < 3 ? <Link href={ '/categories/' + item.id + '-' + item.name }>
                  <div
                    className="inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-dark-blue bg-white font-light text-2xl md:text-lg lg:text-base xl:text-xs border-gray-300 cursor-pointer mr-2 mb-1">{ item.name }</div>
                </Link> : '' }
              </span>
              ) }
              <h1 className="mb-8 mt-3 lg:mt-1 text-4xl sm:text-3xl md:text-3xl lg:text-lg font-normal leading-snug">
                { truncateString(content?.filter(item => item.recommend)?.sort((a, b) => a.recommend.sequence - b.recommend.sequence)[0].title) }
              </h1>
              <div className="text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2">
                { moment(content?.filter(item => item.recommend)?.sort((a, b) => a.recommend.sequence - b.recommend.sequence)[0].created_at).format('MMM DD, YYYY').toUpperCase() }
                { content?.filter(item => item.recommend)?.sort((a, b) => a.recommend.sequence - b.recommend.sequence)[0].timeStamp ?
                  <span className="mx-3">&#8226;</span> : '' }
                { calculateRead(content?.filter(item => item.recommend)?.sort((a, b) => a.recommend.sequence - b.recommend.sequence)[0].timeStamp) }
              </div>
            </div>
          </div>
        </Link>
        <div className="grid grid-rows-1 m-4">
          { content?.filter(item => item.recommend)?.sort((a, b) => a.recommend.sequence - b.recommend.sequence).map((item, index) =>
            <span key={ index }>
              { index > 0 && index < 4 ? <div className={ `${ index < 3 ? 'mb-10 lg:mb-6' : '' } md:flex` }>
                <Link href={ '/blogs/' + item.id + '-' + item.url }>
                  <div className="cursor-pointer">
                    <img src={ strapi + item.imageMobile?.url } loading="lazy"
                      alt={ item.title }
                      className={ `${ style.minW15 } xl:hidden h-96 md:h-60 lg:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover` }/>
                    <img src={ strapi + item.image?.url } loading="lazy"
                      alt={ item.title }
                      className={ `${ style.minW15 } hidden xl:block h-96 md:h-60 lg:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover` }/>
                  </div>
                </Link>
                <div className="mt-10 md:mt-0 px-0 md:px-6 relative flex flex-col justify-between">
                  <Link href={ '/blogs/' + item.id + '-' + item.url }>
                    <div
                      className="text-4xl sm:text-3xl md:text-3xl lg:text-lg font-normal leading-snug cursor-pointer">
                      { truncateString(item.title) }
                    </div>
                  </Link>
                  <div className="text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2">
                    { moment(item.created_at).format('MMM DD, YYYY').toUpperCase() }
                    { item.timeStamp ? <span className="mx-3">&#8226;</span> : '' }
                    { calculateRead(item.timeStamp) }
                    <div>
                      { item.categories.map((tag, i) =>
                        <Link href={ '/categories/' + tag.id + '-' + tag.name } key={ i }>
                          <span>
                            { i < 3 ? <div
                              className="mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-xs cursor-pointer mr-2">
                              { tag.name }</div> : ''
                            }
                          </span>
                        </Link>
                      ) }
                    </div>
                  </div>
                </div>
              </div> : '' }
            </span>
          ) }
        </div>
        <div className="col-span-1 lg:col-span-2">
          <Link href="/issues">
            <div
              className="border-dark-blue text-right py-4 md:py-1 cursor-pointer ">
              <span className="text-4xl md:text-3xl lg:text-2xl">See More &gt;&gt;</span>
            </div>
          </Link>          
        </div>
      </div>

      <hr className="border-dark-blue my-12" style={ { 'borderWidth': '1px' } }/>

      {/*Trending*/ }
      <div className="grid md:block">
        <div className="px-3 w-full lg:w-1/2 inline-block mb-12 lg:mb-0">
          <div className="h-96 bg-no-repeat bg-contain bg-center rounded-2xl"
            style={ { backgroundImage: `url(${ strapi }${ content?.find(item => item.name === 'trend')?.image?.url })` } }/>
        </div>
        { content?.filter(item => item.name === 'article')?.sort((a, b) => a.view < b.view ? 1 : -1).map((item, i) =>
            <span key={ i }>
          { i < 4 ? <div className={ `w-full ${ i === 0 ? 'md:w-1/2' : 'md:w-1/2 lg:w-1/3' } mb-10 inline-block px-3` }>
            <div className="xl:hidden">
              <Link href={ '/blogs/' + item.id + '-' + item.url }>
                <div
                  className={ `${style.trendingHeight} bg-no-repeat bg-center bg-cover rounded-2xl w-5/6 ${ i === 0 ? 'md:w-2/3' : 'md:w-3/4'} ml-auto relative shadow-2xl cursor-pointer` }
                  style={ { backgroundImage: `url(${ strapi }${ item.imageMobile?.url })` } }>
                  <span className={ `${ style.trending } absolute` }>{ i + 1 }</span>
                </div>
              </Link>
            </div>
            <div className="hidden xl:block">
              <Link href={ '/blogs/' + item.id + '-' + item.url }>
                <div
                  className={ `${style.trendingHeight} bg-no-repeat bg-center bg-cover rounded-2xl w-5/6 ${ i === 0 ? 'md:w-2/3' : 'md:w-3/4'} ml-auto relative shadow-2xl cursor-pointer` }
                  style={ { backgroundImage: `url(${ strapi }${ item.image?.url })` } }>
                  <span className={ `${ style.trending } absolute` }>{ i + 1 }</span>
                </div>
              </Link>
            </div>
            <div className="w-5/6 md:w-3/4 ml-auto mt-3">
              <Link href={ '/blogs/' + item.id + '-' + item.url }>
                <span className={ `text-3xl lg:text-lg cursor-pointer ${ style.lineClamp } pt-3` }>{ item.title }</span>
              </Link>
              <div className="justify-between flex text-3xl md:text-xl mt-2">
                <Link href="/issues"><span className="cursor-pointer">Issue</span></Link>
                <span className='mw-70percent'>
                  { item.categories.map((tag, i) =>
                    <Link href={ '/categories/' + tag.id + '-' + tag.name } key={ i }>
                      <span>
                        { i < 3 ? <div
                          className="mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-base xl:text-xs cursor-pointer mr-2">
                          { tag.name }</div> : ''
                        }
                      </span>
                    </Link>
                  ) }
                </span>
              </div>
            </div>
          </div> : '' }
        </span>
        ) }
      </div>
      {/*Trending*/ }

      <hr className="border-dark-blue my-12" style={ { 'borderWidth': '1px' } }/>

      {/* Recent Stories*/ }
      <div className="text-5xl font-bold mb-12">Recent Stories</div>
      <div className="grid grid-cols-1 lg:grid-cols-2">
        { content?.filter(item => item.name === 'article')?.sort((a, b) => a.id < b.id ? 1 : -1).map((item, index) =>
          <span key={ index }>
            { index < 4 ? <div className={ `${ index < 3 ? 'mb-10 lg:mb-6' : '' } md:flex` }>
              <Link href={ '/blogs/' + item.id + '-' + item.url }>
                <div>
                  <img src={ strapi + item.imageMobile?.url } loading="lazy"
                    alt={ item.title }
                    className={ `${ style.minW15 } xl:hidden h-96 md:h-60 lg:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer` }/>
                  <img src={ strapi + item.image?.url } loading="lazy"
                    alt={ item.title }
                    className={ `${ style.minW15 } hidden xl:block h-96 md:h-60 lg:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer` }/>
                </div>
              </Link>
              <div className="mt-10 md:mt-0 px-0 md:px-6 relative flex flex-col justify-between">
                <Link href={ '/blogs/' + item.id + '-' + item.url }>
                  <div className="text-4xl sm:text-3xl md:text-3xl lg:text-lg font-normal leading-snug cursor-pointer">
                    { truncateString(item.title) }
                  </div>
                </Link>

                <div className="text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2">
                  { moment(item.created_at).format('MMM DD, YYYY').toUpperCase() }
                  { item.timeStamp ? <span className="mx-3">&#8226;</span> : '' }
                  { calculateRead(item.timeStamp) }
                  <div>
                    { item.categories.map((tag, i) =>
                      <Link href={ '/categories/' + tag.id + '-' + tag.name } key={ i }>
                        <span>
                          { i < 3 ? <div key={ i }
                            className="mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-xs cursor-pointer mr-2">
                            { tag.name }</div> : ''
                          }
                        </span>
                      </Link>
                    ) }
                  </div>
                </div>
              </div>
            </div> : '' }
          </span>
        ) }
      </div>
      {/* Recent Stories*/ }

      <hr className="border-dark-blue my-12" style={ { 'borderWidth': '1px' } }/>

      {/* Video */ }
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div className="relative order-2 lg:order-1">
          <ModalVideo channel="youtube" autoplay isOpen={ isOpen }
            videoId={ categories?.find((obj: any) => obj.name === 'Video')?.link }
            onClose={ () => setOpen(false) }/>
          <img
            src={ strapi + categories?.find(obj => obj.name === 'Video')?.videoCover?.url }
            loading="lazy"
            alt={ categories?.find(obj => obj.name === 'Video')?.name }
            className="w-full rounded-2xl cursor-pointer"
            onClick={ () => setOpen(true) }/>
          <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => setOpen(true) }
            className="text-white fa-7x lg:fa-5x absolute absolute-center"/>
        </div>
        <div className="place-self-center order-1 lg:order-2">
          <img src={`${strapi}/uploads/Group_13715_2x_2cf33a651e.png`} loading="lazy"
            alt="" className="w-full h-96 lg:h-60 xl:h-40 rounded-2xl object-cover"/>
          <Link href={ '/categories/' + categories?.find(obj => obj.name === 'Video').id + '-Video' }>
            <div className="text-right text-5xl lg:text-2xl mt-5 mx-3 cursor-pointer">See More</div>
          </Link>
        </div>
      </div>
      <Carousel className="blog" responsive={ responsive }>
        { categories?.find(obj => obj.name === 'Video')?.blogs?.sort((a, b) => a.id < b.id ? 1 : -1).map((item, i) =>
          <Link href={{ 
              pathname: '/categories/' + categories?.find(obj => obj.name === 'Video').id + '-Video',
              query: {
                videoId: item.id
              }
            }} key={ i }>
            <span>
            <div className="m-4 shadow-lg bg-white cursor-pointer relative xl:h-auto rounded-2xl">
              <img src={ strapi + item.imageMobile?.url } loading="lazy"
                alt={ item.title } className="xl:hidden w-full h-96 md:h-60 xl:h-40 rounded-2xl object-cover"/>
              <img src={ strapi + item.image?.url } loading="lazy"
                alt={ item.title } className="hidden xl:block w-full h-96 md:h-60 xl:h-40 rounded-2xl object-cover"/>
            </div>
            <div className="m-5 text-center cursor-pointer text-4xl sm:text-3xl lg:text-2xl xl:text-lg 2xl:text-xl">
              { item.title }
            </div>
            </span>
          </Link>
        ) }
      </Carousel>
      {/* Video */ }

      <hr className="border-dark-blue my-12" style={ { 'borderWidth': '1px' } }/>

    </div>
    {/* Explore */ }
    <div className="text-5xl font-bold mb-12 text-center">Let&apos;s Explore these Categories</div>
    <Carousel className="explore" responsive={ categoriesResponsive }>
      { categories?.sort((a, b) => a.id < b.id ? 1 : -1).map((item, i) =>
        <Link href={ '/categories/' + item?.id + '-' + item?.name } key={ i }>
          <div className="relative text-center" onMouseOver={ () => setHoverTag(i) } onMouseLeave={ () => setHoverTag(null) }>
            <img className="w-full h-80 object-cover cursor-pointer" alt="hero" src={ strapi + item.image?.url }/>
            <div
              className="xl:hidden absolute absolute-center text-white text-9xl md:text-6xl cursor-pointer underline wrap-anywhere break-words w-11/12">{ item.name?.toUpperCase() }</div>
            { hoverTag === i ? <div
              className={ `${ style.fadeIn } hidden xl:block absolute absolute-center text-white text-9xl md:text-6xl cursor-pointer underline wrap-anywhere break-words w-11/12` }>{ item.name?.toUpperCase() }</div> : '' }
          </div>
        </Link>
      ) }
    </Carousel>
    {/* Explore */ }
    <div className="px-12 xl:px-24">
      <hr className="border-dark-blue my-12" style={ { 'borderWidth': '1px' } }/>
    </div>

    {/*<Subscribe/>*/}
    <Subscribe/>
  </>
}

Blogs.getLayout = (page: ReactElement) => {
  return <OldLayout>{page}</OldLayout>;
};

export default Blogs;
